import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import { Problem, Services, Advantages, ForWhom } from "@/components/site/MidSections";
import { Showreel, ContentFormats, Sponsorships, CaseStudies } from "@/components/site/ExtraSections";
import Fernando from "@/components/site/Fernando";
import Pricing from "@/components/site/Pricing";
import { Portfolio, Method } from "@/components/site/Showcase";
import FaqSection from "@/components/site/FaqSection";
import ContactSection from "@/components/site/ContactSection";
import Footer from "@/components/site/Footer";
import Floaters from "@/components/site/Floaters";

export default function Home() {
  return (
    <div className="relative bg-[#050505] min-h-screen">
      <Navbar />
      <main>
        <Hero />
        <Showreel />
        <Problem />
        <Services />
        <ContentFormats />
        <Advantages />
        <Pricing />
        <Sponsorships />
        <Portfolio />
        <CaseStudies />
        <Fernando />
        <ForWhom />
        <Method />
        <FaqSection />
        <ContactSection />
      </main>
      <Footer />
      <Floaters />
    </div>
  );
}
